module.exports = __webpack_public_path__ + "static/media/sports-medal.ca588f78.png";